import NewBattery from './NewBattery.vue'

export default NewBattery
